"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertEnum = convertEnum;
function convertEnum(value, values, defaultValue, log) {
    if (!value) {
        return defaultValue;
    }
    if (values.includes(value)) {
        return value;
    }
    log(`background type ${value} is invalid`);
    return defaultValue;
}
//# sourceMappingURL=convertEnum.js.map